import axios from 'axios';
import { confirm } from '../shared/helpers/confirm';

const axiosFetch = async (method = 'GET', url = '', data = {}, config = {}) => {
  try {
    const response = await axios.request({
      url: config?.baseUrl ? config.baseUrl + url : url,
      method,
      data,
      headers: { 'content-type': 'application/json' },
      ...config,
    });
    return Promise.resolve(response);
  } catch (error) {
    if (error && error.msg === 'Token Renewal Failed') {
      window.location.reload();
    }
    // This is a validation error from the Model checks
    if (error?.response?.data?.title) {
      console.dir(error?.response?.data?.errors);
      error.response.data.Detail = error.response.data.title;
    }

    return Promise.reject(error);
  }
};

// Delete with confirmation
// May move "deleted successfully" here latter so it's not repeated in code
const WithConfirmation = async (url, config, method='DELETE', data=null) => {
  console.log({url, config, method, data});
  try {
    const confirmed = await confirm({
      title: 'Confirm Delete',
      message: `Are you sure you want to delete this item?`,
      confirmText: 'Delete',
      cancelText: 'Cancel',
      ...config?.confirmOptions ?? {},
    });
    
    if (confirmed) {
      return axiosFetch(method, url, data, config);
    } else {
      return Promise.reject(new Error('Delete operation cancelled by user'));
    }
  } catch (error) {
    return Promise.reject(error);
  }
};

const authFetch = {
  get: (url, config) => axiosFetch('GET', url, null, config),
  patch: (url, data, config) => axiosFetch('PATCH', url, data, config),
  put: (url, data, config) => (config?.confirmOptions || config?.confirm === true) ? WithConfirmation(url, config, 'PUT', data) : axiosFetch('PUT', url, data, config),
  post: (url, data, config) => (config?.confirmOptions || config?.confirm === true) ? WithConfirmation(url, config, 'POST', data) : axiosFetch('POST', url, data, config),
  delete: (url, config) => WithConfirmation(url, config),
};

export default authFetch;
